export function formatTime(dateString, format = 'full') {
  const date = new Date(dateString);

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  // const seconds = String(date.getSeconds()).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  if (format === 'time') {
    return `${hours}:${minutes}`;
  }

  return `${day}/${month}/${year} - ${hours}:${minutes}`;
}

export function formatDate(date) {
  if (!date) return "-";
  const d = new Date(date);
  const pad = (num) => num.toString().padStart(2, "0");

  const day = pad(d.getDate());
  const month = pad(d.getMonth() + 1);
  const year = d.getFullYear().toString().slice(-2);
  const hours = pad(d.getHours());
  const minutes = pad(d.getMinutes());
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}
export function formateISODate(date) {
  const localDate = new Date(date);
  const offset = localDate.getTimezoneOffset();
  const adjustedDate = new Date(localDate.getTime() - (offset * 60 * 1000));
  return adjustedDate.toISOString().split('T')[0];
}
export function timeSpan(time_start, time_end) {
  const now = new Date(time_start);
  const targetDate = new Date(time_end);
  const diffInSeconds = Math.floor((now - targetDate) / 1000);
  
  const hours = Math.floor(diffInSeconds / 3600);
  const minutes = Math.floor((diffInSeconds % 3600) / 60);
  const seconds = diffInSeconds % 60;
  
  if (hours > 0) {
    return `${hours} jam ${minutes} menit`;
  } else if (minutes > 0) {
    return `${minutes} menit`;
  } else {
    return `${seconds} detik`;
  }
}